import { TerritoryModel } from './territory.model';

export class LanguageModel {
  public id: number = null;
  public label = '';
  public isoCode = '';
  public IsLanguageTech: boolean = null;
  public order = 0;
  public territories: TerritoryModel[];

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
